<div class="role-panel role-panel--mover info-card order-workspace">
  <h2 class="role-panel__title">{{
    'staff.orders.cockpit.moverPanelTitle' | translate
  }}</h2>
      <div class="order-workspace__section role-actions role-actions--mover">
        @if (facade.canMoverStart()) {
        <lib-cabinet-button
          class="processing-action"
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="'admin.storageRequests.moverStart' | translate"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving()"
          [isLoading]="facade.savingMode() === 'mover'"
          (actionEvent)="facade.moverStart()"
        />
        }
        @if (facade.showMoverTransitButton()) {
        <lib-cabinet-button
          class="processing-action"
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="facade.moverTransitLabelKey() | translate"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving() || !facade.canSubmitMoverTransit()"
          [isLoading]="facade.savingMode() === 'mover'"
          (actionEvent)="facade.moverTransit()"
        />
        @if (facade.showMoverTransitBlockedHint()) {
        <p class="role-actions__hint">
          {{ 'admin.moverInventory.transitBlockedHint' | translate }}
        </p>
        }
        }
        @if (facade.canMoverDelivered()) {
        <lib-cabinet-button
          class="processing-action"
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="'admin.storageRequests.moverDelivered' | translate"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving()"
          [isLoading]="facade.savingMode() === 'mover'"
          (actionEvent)="facade.moverDelivered()"
        />
        }
      </div>
      @if (facade.showMoverOrderLines()) {
      <div class="order-workspace__section mover-order-lines">
      <div class="mover-order-lines__head">
        <h3 class="mover-order-lines__title core-title">
          {{ 'admin.storageRequests.sectionOrderItems' | translate }}
        </h3>
        @if (facade.moverAcceptProgress(); as progress) {
        <p class="mover-order-lines__progress">
          {{
            'admin.moverInventory.acceptProgress'
              | translate: { accepted: progress.accepted, total: progress.total }
          }}
        </p>
        }
      </div>

      @if (facade.inventoryLoading()) {
      <p class="mover-order-lines__loading">
        {{ 'admin.storageRequests.orderItemsLoading' | translate }}
      </p>
      } @else if (facade.storage(); as inv) {
        @if (inv.lines.length > 0) {
        <div class="mover-order-lines__table-wrap">
          <table class="mover-order-lines__table">
            <thead>
              <tr>
                <th scope="col">
                  {{ 'admin.storageRequests.orderItemsColName' | translate }}
                </th>
                <th scope="col">
                  {{ 'admin.storageRequests.orderItemsColKind' | translate }}
                </th>
                <th scope="col">
                  {{ 'admin.storageRequests.orderItemsColStatus' | translate }}
                </th>
                <th scope="col">
                  {{ 'admin.storageRequests.orderItemsColActions' | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              @for (line of inv.lines; track line.id) {
              <tr class="mover-order-lines__row">
                <td>{{ facade.orderCompositionLineLabel(line) }}</td>
                <td>
                  {{
                    (facade.orderCompositionLineKind(line) === 'box'
                      ? 'admin.storageRequests.orderItemsKindBox'
                      : facade.orderCompositionLineKind(line) === 'item'
                        ? 'admin.storageRequests.orderItemsKindItem'
                        : 'admin.storageRequests.orderItemsKindUnknown'
                    ) | translate
                  }}
                </td>
                <td>{{ facade.compositionLineStatusLabel(line) }}</td>
                <td class="mover-order-lines__actions">
                  @if (facade.orderLineAcceptBoxId(line); as boxId) {
                  <div class="mover-order-lines__action-group">
                    <button
                      type="button"
                      class="mover-order-lines__action"
                      [disabled]="facade.saving()"
                      (click)="facade.printMoverQr(boxId, 'box')"
                    >
                      {{ 'admin.moverInventory.printQr' | translate }}
                    </button>
                    <button
                      type="button"
                      class="mover-order-lines__action mover-order-lines__action--primary"
                      [disabled]="facade.saving() || facade.orderLineIsMoverAccepted(line)"
                      (click)="facade.moverAcceptBox(boxId)"
                    >
                      {{ 'admin.moverInventory.acceptBox' | translate }}
                    </button>
                  </div>
                  } @else if (line.item_id) {
                  <div class="mover-order-lines__standalone">
                    <p class="mover-order-lines__standalone-label">
                      {{ 'admin.moverInventory.standaloneFlow' | translate }}
                    </p>
                    <div class="mover-order-lines__action-group">
                      <button
                        type="button"
                        class="mover-order-lines__action"
                        [disabled]="facade.saving()"
                        (click)="facade.printMoverQr(line.item_id!, 'item')"
                      >
                        {{ 'admin.moverInventory.printQr' | translate }}
                      </button>
                      <button
                        type="button"
                        class="mover-order-lines__action mover-order-lines__action--primary"
                        [disabled]="
                          facade.saving() || facade.orderLineIsMoverAccepted(line)
                        "
                        (click)="facade.moverAcceptItem(line.item_id!)"
                      >
                        {{ 'admin.moverInventory.acceptItem' | translate }}
                      </button>
                    </div>
                    @if (!facade.orderLineItemInBox(line)) {
                    <div class="mover-order-lines__assign">
                      <span class="mover-order-lines__assign-label">{{
                        'admin.moverInventory.assignToBoxLabel' | translate
                      }}</span>
                      @if (inv.boxes.length > 0) {
                      <div class="mover-order-lines__assign-row">
                        <select
                          class="mover-order-lines__select"
                          [ngModel]="facade.moverLineSelectedBoxId(line.id)"
                          (ngModelChange)="facade.onMoverLineBoxChange(line.id, $event)"
                        >
                          @for (box of inv.boxes; track box.box_id) {
                          <option [value]="box.box_id">{{
                            facade.shortBoxId(box.box_id)
                          }}</option>
                          }
                        </select>
                        <button
                          type="button"
                          class="mover-order-lines__action"
                          [disabled]="
                            facade.saving() || !facade.moverLineSelectedBoxId(line.id)
                          "
                          (click)="facade.assignMoverLineToBox(line)"
                        >
                          {{ 'admin.moverInventory.assignToBox' | translate }}
                        </button>
                      </div>
                      } @else {
                      <p class="mover-order-lines__assign-hint">{{
                        'admin.moverInventory.assignToBoxNeedBox' | translate
                      }}</p>
                      }
                    </div>
                    }
                  </div>
                  }
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @else {
        <p class="mover-order-lines__empty">
          {{ 'admin.storageRequests.orderItemsEmpty' | translate }}
        </p>
        }
      }
      </div>
      }

      @if (facade.canMoverInventory()) {
      <div class="order-workspace__section mover-inventory">
        <h3 class="mover-inventory__title core-title">
          {{ 'admin.moverInventory.title' | translate }}
        </h3>
        <p class="mover-inventory__hint">
          {{ 'admin.moverInventory.hint' | translate }}
        </p>
        @if (!facade.row()?.user_id) {
        <p class="mover-inventory__alert" role="alert">
          {{ 'admin.moverInventory.anonymousNoBoxes' | translate }}
        </p>
        } @else {
        @if (facade.inventoryLoading()) {
        <p class="mover-inventory__loading">
          {{ 'admin.moverInventory.loading' | translate }}
        </p>
        } @else if (facade.storage(); as inv) {
        @for (b of inv.boxes; track b.box_id) {
        <div class="mover-inventory__box">
          <div class="mover-inventory__box-head">
            <span class="mover-inventory__box-label"
              >{{ 'admin.moverInventory.boxLabel' | translate }}</span
            >
            <span class="mover-inventory__box-id mono">{{
              facade.shortBoxId(b.box_id)
            }}</span>
            <span class="mover-inventory__box-status">{{
              facade.storageStatusLabel(b.status)
            }}</span>
            <button
              type="button"
              class="mover-inventory__copy"
              (click)="facade.copyToClipboard(b.box_id)"
              [attr.aria-label]="'common.copy' | translate"
            >
              <img
                src="/icons/core/copy.svg"
                alt=""
                width="16"
                height="16"
              />
            </button>
          </div>
          <div class="mover-inventory__box-actions">
            <button
              type="button"
              class="mover-inventory__inline-action"
              [disabled]="facade.saving()"
              (click)="facade.printMoverQr(b.box_id, 'box')"
            >
              {{ 'admin.moverInventory.printQr' | translate }}
            </button>
            <button
              type="button"
              class="mover-inventory__inline-action mover-inventory__inline-action--primary"
              [disabled]="facade.saving() || facade.isBoxMoverAccepted(b.box_id)"
              (click)="facade.moverAcceptBox(b.box_id)"
            >
              {{ 'admin.moverInventory.acceptBox' | translate }}
            </button>
          </div>
          <ul class="mover-inventory__items">
            @for (it of b.items; track it.id) {
            <li class="mover-inventory__item-row">
              <span class="mover-inventory__item-name">{{ it.name }}</span>
              <span class="mover-inventory__item-status">{{
                facade.storageStatusLabel(it.status)
              }}</span>
              @if (facade.canReleaseItemsToClient()) {
              <button
                type="button"
                class="mover-inventory__release"
                [disabled]="facade.saving()"
                (click)="facade.releaseMoverItem(it.id)"
              >
                {{ 'admin.moverInventory.releaseItem' | translate }}
              </button>
              }
            </li>
            }
          </ul>
        </div>
        }
        @if (inv.boxes.length === 0) {
        <p class="mover-inventory__empty">
          {{ 'admin.moverInventory.empty' | translate }}
        </p>
        }

        <div class="mover-inventory__form-block">
          <span class="field-label">{{
            'admin.moverInventory.newBox' | translate
          }}</span>
          <div class="mover-inventory__row">
            <label class="mover-inventory__select-wrap">
              <span class="sr-only">{{
                'admin.moverInventory.boxSize' | translate
              }}</span>
              <select
                class="mover-inventory__select"
                [ngModel]="facade.selectedBoxSizeId()"
                (ngModelChange)="facade.selectedBoxSizeId.set($event)"
              >
                @for (sz of facade.boxSizeOptions(); track sz.id) {
                <option [value]="sz.id">{{ sz.name }}</option>
                }
              </select>
            </label>
            <lib-cabinet-button
              class="mover-inventory__btn"
              variant="primary"
              size="md"
              [fullWidth]="true"
              [text]="'admin.moverInventory.createBox' | translate"
              [action]="{ type: 'action' }"
              [disabled]="facade.saving() || !facade.selectedBoxSizeId()"
              [isLoading]="facade.savingMode() === 'box'"
              (actionEvent)="facade.createMoverBox()"
            />
          </div>
        </div>

        <div class="mover-inventory__form-block">
          <span class="field-label">{{
            'admin.moverInventory.newItem' | translate
          }}</span>
          <label class="mover-inventory__select-wrap">
            <span class="field-label field-label--small">{{
              'admin.moverInventory.selectBox' | translate
            }}<span class="field-label-required" aria-hidden="true">*</span></span>
            <select
              class="mover-inventory__select"
              [ngModel]="facade.newItemBoxId()"
              (ngModelChange)="facade.newItemBoxId.set($event)"
            >
              @for (b of inv.boxes; track b.box_id) {
              <option [value]="b.box_id">{{ facade.shortBoxId(b.box_id) }}</option>
              }
            </select>
          </label>
          <lib-not-input
            type="text"
            [label]="'admin.moverInventory.itemName' | translate"
            [required]="true"
            [ngModel]="facade.newItemName()"
            (ngModelChange)="facade.newItemName.set($event)"
            [hideErrorBlock]="true"
          />
          <lib-not-input
            type="number"
            [label]="'CLIENT.CABINET.ITEM_CATALOG.FIELD_QUANTITY' | translate"
            [placeholder]="
              'CLIENT.CABINET.ITEM_CATALOG.FIELD_QUANTITY_PLACEHOLDER' | translate
            "
            [ngModel]="facade.newItemQuantity()"
            (ngModelChange)="facade.newItemQuantity.set($event)"
            [hideErrorBlock]="true"
          />
          <p class="mover-inventory__hint">
            {{ 'CLIENT.CABINET.ITEM_CATALOG.DIMENSIONS_IN_BOX_HINT' | translate }}
          </p>
          <label class="mover-inventory__toggle">
            <input
              type="checkbox"
              [ngModel]="facade.newItemIsDisassembled()"
              (ngModelChange)="facade.newItemIsDisassembled.set($event)"
            />
            <span>{{
              'CLIENT.CABINET.ITEM_CATALOG.FIELD_DISASSEMBLED' | translate
            }}</span>
          </label>
          @if (facade.newItemIsDisassembled()) {
            <lib-not-input
              type="number"
              [label]="'CLIENT.CABINET.ITEM_CATALOG.FIELD_PARTS_COUNT' | translate"
              [required]="true"
              [ngModel]="facade.newItemPartsCount()"
              (ngModelChange)="facade.newItemPartsCount.set($event)"
              [hideErrorBlock]="true"
            />
          }
          <label class="mover-inventory__photo">
            <span class="field-label field-label--small">{{
              'admin.moverInventory.itemPhoto' | translate
            }}</span>
            <input
              type="file"
              accept="image/jpeg,image/png,image/webp"
              (change)="facade.onNewItemPhoto($event)"
            />
          </label>
          <lib-cabinet-button
            class="mover-inventory__btn"
            variant="primary"
            size="lg"
            [fullWidth]="true"
            [text]="'admin.moverInventory.addItem' | translate"
            [action]="{ type: 'action' }"
            [disabled]="facade.saving() || !facade.canSubmitNewMoverItem()"
            [isLoading]="facade.savingMode() === 'item'"
            (actionEvent)="facade.addMoverItem()"
          />
        </div>
        }
        }
      </div>
      }
</div>
